export default __webpack_public_path__ + "static/media/motA2.38852f02.png";